import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import DOMPurify from 'dompurify';
import marked from 'marked';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { useIntl, FormattedTime } from 'react-intl';
import { withRoomContext } from '../../../../../RoomContext';
import { connect } from 'react-redux';
import { makePermissionSelector } from '../../../../../store/selectors';
import { permissions } from '../../../../../permissions';

const styles = (theme) =>
	({
		root :
		{
			display    : 'flex',
			flexShrink : 0,
			// backgroundColor: '#a9daeb',
			boxShadow  : 'none',
			padding    : '0',
			wordWrap   : 'break-word',
			wordBreak  : 'break-all',
			alignItems : 'center',
			fontFamily : 'Twemoji Country Flags'
		},
		single :
		{
			marginTop    : theme.spacing(1),
			borderRadius : '10px 10px 10px 10px'
		},
		combinedBegin :
		{
			marginTop    : theme.spacing(1),
			borderRadius : '10px 10px 0px 0px'
		},

		combinedMiddle :
		{
			marginBottom : theme.spacing(0),
			borderRadius : '0px 0px 0px 0px'
		},
		combinedEnd :
		{
			marginBottom : theme.spacing(0),
			borderRadius : '0px 0px 10px 10px'
		},
		combinedTime :
		{
			width          : '75px',
			alignSelf      : 'center',
			fontSize       : '13px',
			color          : '#999999',
			dispay         : 'flex',
			display        : 'flex',
			justifyContent : 'center'
		},
		sent :
		{
			flexDirection : 'row-reverse',
			width         : '100%'
		},
		received :
		{
			width      : '100%',
			alignItems : 'flex-end',
			position   : 'relative'
		},
		name : {

		},
		avatar : {
			display        : 'flex',
			justifyContent : 'center',
			padding        : '12px 6px 20px 0px',
			'& img'        : {
				borderRadius    : '50%',
				width           : '2rem',
				height          : '2rem',
				alignSelf       : 'center',
				objectFit       : 'cover',
				backgroundColor : '#e0e0e085'
			}
		},
		content :
		{
			margin : theme.spacing(1),
			'& p'  : {
				margin : '0'
			}
		},
		isSeen : {
			backgroundColor : '#e0e0e085',
			transition      : 'background-color 1s'
		}
	});

const WebinarMessage = (props) =>
{
	const intl = useIntl();

	const avatarRef = useRef(null);
	const msgRef = useRef(null);
	const [ totalWidth, setTotalWidth ] = useState(0);

	const linkRenderer = new marked.Renderer();

	linkRenderer.link = (href, title, text) =>
	{
		title = title ? title : href;
		text = text ? text : href;

		return `<a target='_blank' href='${ href }' title='${ title }'>${ text }</a>`;
	};

	const allowedHTMLNodes = {
		ALLOWED_TAGS : [
			'a', 'b', 'strong', 'i',
			'em', 'u', 'strike', 'p',
			'br'
		],
		ALLOWED_ATTR : [ 'href', 'target', 'title' ]
	};

	const {
		avatar,
		message,
		sendTime,
		userName,
		classes,
		refMessage,
		peerId,
		sender,
		webinarUser,
		isseen,
		me,
		item,
		isModerator,
		setReplyData
		// format
	} = props;

	const [ imageError, setImageError ] = useState(false);

	const handleImageError = () =>
	{
		setImageError(true);
	};

	useEffect(() =>
	{
		// Ensure the refs are set before calculating width
		if (avatarRef.current && msgRef.current)
		{
			const width1 = avatarRef.current.offsetWidth;
			const width2 = msgRef.current.offsetWidth;

			setTotalWidth(width1 + width2 + 12);
		}
	}, []);

	return (
		<Paper
			className={classnames(
				classes.root,
				(window.btoa(me.email) === peerId) ? classes.sent : classes.received,
				classes.single, 'parentMsg'
			)}
			data-name={userName}
			data-time={sendTime}
			data-isseen={isseen || false}
			ref={refMessage}
		>
			{/* <div className={classes.content}>
				<Typography variant='subtitle1'>
					<b>
						{ sender === peerId ?
							`${intl.formatMessage({
								id             : 'room.me',
								defaultMessage : 'Me'
							}) }`
							:
							<b>{userName}</b>
						} - <FormattedTime value={new Date(sendTime)} />
					</b>
				</Typography>

				<Typography
					variant='subtitle1'
					// eslint-disable-next-line react/no-danger
					dangerouslySetInnerHTML={{ __html : DOMPurify.sanitize(
						marked.parse(message, { renderer: linkRenderer }),
						allowedHTMLNodes
					) }}
				/>
			</div> */}

			{!(window.btoa(me.email) === peerId) &&
			<div className={classes.avatar} ref={avatarRef}>
				<img src={avatar && avatar !== '' && !imageError ? `https://${import.meta.env.VITE_s3Bucket}.s3.${import.meta.env.VITE_s3Region}.amazonaws.com/public/profileImages/${avatar}}` : 'images/avatar.svg'} onError={(e) => { e.target.onerror = null; handleImageError(); }} alt='Avatar' />
			</div>
			}

			<div className='msgCntnr' ref={msgRef}>
				<div className={(window.btoa(me.email) === peerId) ? 'meMsg' : 'peerMsg'} style={(window.btoa(me.email) === peerId) ? { backgroundColor: '#a9daeb', borderColor: '#a9daeb' } : { backgroundColor: '#eaecf2', borderColor: '#eaecf2' }}>
					{/* Name & Time */}
					{/* {(format === 'single' || format === 'combinedBegin') && */}
					{/* <Typography variant='subtitle1'> */}
					{
						(window.btoa(me.email) === peerId)
							? ''
						// `${intl.formatMessage({
						// 	id: 'room.me',
						// 	defaultMessage: 'Me'
						// })}`
							:
							<small>{userName}</small>
					}
					{/* </Typography> */}
					{/* } */}
					<Typography
						variant='subtitle1'
						// eslint-disable-next-line react/no-danger
						dangerouslySetInnerHTML={{ __html : DOMPurify.sanitize(
							marked.parse(message, { renderer: linkRenderer }),
							allowedHTMLNodes
						) }}
						className='flagss'
					/>
				</div>
				{isModerator && item?.replyTo && <small style={{ color: '#d19065', fontFamily: 'roboto' }}>Replied to {item?.replyData?.userName} </small>}
				<small style={{ fontFamily: 'roboto' }} className={window.btoa(me.email) === peerId ? 'flexRow aEnd jEnd' : ''}>
					<FormattedTime value={new Date(sendTime)} />
				</small>
			</div>
			{isModerator && window.btoa(me.email) !== peerId && <div className='reply1' style={{ left: `${totalWidth}px`, width: '32px' }} onClick={() => setReplyData(item)}>
				<img className='pdngXXS' src='/icons/reply1.svg' alt='reply' />
			</div>}
		</Paper>
	);
};

WebinarMessage.propTypes =
{
	meetingId    : PropTypes.string,
	avatar       : PropTypes.string,
	message      : PropTypes.string,
	sendTime     : PropTypes.any,
	userName     : PropTypes.string,
	userId       : PropTypes.string,
	classes      : PropTypes.object.isRequired,
	isseen       : PropTypes.any,
	sender       : PropTypes.string.isRequired,
	refMessage   : PropTypes.object,
	width        : PropTypes.number,
	format       : PropTypes.string,
	peerId       : PropTypes.string.isRequired,
	webinarUser  : PropTypes.any,
	setReplyData : PropTypes.any,
	me           : PropTypes.any,
	item         : PropTypes.any,
	isModerator  : PropTypes.any
};

const makeMapStateToProps = () =>
{
	const hasPermission = makePermissionSelector(permissions.MODERATE_ROOM);

	const mapStateToProps = (state) =>
		({
			me          : state.me,
			isModerator : hasPermission(state)

		});

	return mapStateToProps;
};

export default withRoomContext(
	connect(
		makeMapStateToProps,
		null,
		null,
		{
			areStatesEqual : (next, prev) =>
			{
				return (
					prev.me.id === next.me.id
				);
			}
		}
	)(withStyles(styles)(WebinarMessage))
);